import React from "react";
import useImageSize from "../../../../../../hooks/global/useImageSize";

export const ListingModalSwapLimitReachedItemImage = ({
  image,
}: {
  image: string;
}) => {
  const [resizedImage] = useImageSize({
    imageUrl: image,
    size: 300,
    isCover: true,
    originalFormat: true,
  });

  return (
    <img
      className="w-[56px] h-[56px] object-cover"
      title="Listing | Pod1um"
      alt="Listing | Pod1um"
      src={resizedImage}
    />
  );
};
